import React from "react";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/site";

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 bg-brand-ink"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-brand-gold/90">
              <span className="inline-block h-px w-10 bg-brand-gold" />
              What we do
            </div>
            <h2 className="mt-4 font-serif text-4xl md:text-6xl text-white leading-tight max-w-3xl text-balance">
              Three trades.{" "}
              <span className="text-brand-gold italic">One standard.</span>
            </h2>
          </div>
          <p className="max-w-md text-white/70 text-base md:text-lg">
            Specialists in modern silicone & monocouche renders, hand-skimmed
            plaster, and full drylining packages — domestic to multi-plot
            commercial.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 auto-rows-[220px] md:auto-rows-[280px]">
          {SERVICES.map((s) => (
            <a
              key={s.key}
              href="#contact"
              data-testid={`service-card-${s.key}`}
              className={`group relative overflow-hidden rounded-sm border border-white/5 hover:border-brand-gold/40 transition-all duration-500 col-span-1 ${s.span}`}
            >
              <img
                src={s.image}
                alt={s.title}
                className="absolute inset-0 h-full w-full object-cover scale-105 group-hover:scale-110 transition-transform duration-[1200ms]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-ink via-brand-ink/40 to-transparent" />
              <div className="relative h-full flex flex-col justify-end p-6 md:p-8">
                <div className="flex items-center justify-between gap-4">
                  <h3 className="font-serif text-2xl md:text-4xl text-white tracking-tight">
                    {s.title}
                  </h3>
                  <span className="h-10 w-10 inline-flex items-center justify-center rounded-full border border-brand-gold/40 text-brand-gold opacity-80 group-hover:opacity-100 group-hover:bg-brand-gold group-hover:text-black transition-all">
                    <ArrowUpRight className="h-4 w-4" />
                  </span>
                </div>
                <p className="mt-3 text-sm md:text-base text-white/75 max-w-md leading-relaxed">
                  {s.blurb}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
